import { Directive, HostListener, inject, Input, NgModule } from '@angular/core';

import { SpotlightKey } from '@reach/interfaces/spotlights/spotlights.enum';

import { OnboardingService } from '~app-client/onboarding/services';

@Directive({
	// eslint-disable-next-line @angular-eslint/prefer-standalone
	standalone: false,
	selector: '[onboardingSpotlightModal]',
})
export class OnboardingSpotlightModalDirective {
	private readonly onboardingService = inject(OnboardingService);

	@Input()
	public onboardingSpotlightModal?: SpotlightKey;

	@HostListener('click')
	public _onClick(): void {
		if (!this.onboardingSpotlightModal) {
			return;
		}

		void this.onboardingService.showOnboardingModal(this.onboardingSpotlightModal);
	}
}

@NgModule({
	declarations: [OnboardingSpotlightModalDirective],
	exports: [OnboardingSpotlightModalDirective],
})
export class OnboardingSpotlightModalDirectiveModule {}
